import { render, staticRenderFns } from "./JacRegionCreate.vue?vue&type=template&id=2d3adf56&scoped=true"
import script from "./JacRegionCreate.vue?vue&type=script&lang=js"
export * from "./JacRegionCreate.vue?vue&type=script&lang=js"
import style0 from "./JacRegionCreate.vue?vue&type=style&index=0&id=2d3adf56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3adf56",
  null
  
)

export default component.exports